import { render, staticRenderFns } from "./event-translation.vue?vue&type=template&id=17daf80e&scoped=true"
import script from "./event-translation.vue?vue&type=script&lang=js"
export * from "./event-translation.vue?vue&type=script&lang=js"
import style0 from "./event-translation.vue?vue&type=style&index=0&id=17daf80e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17daf80e",
  null
  
)

export default component.exports